import {
  MaterialUICore,
  TextField as DSTextField,
  Button as DSButton,
  axiomTokens,
} from '@iclinic/design-system';

const { styled } = MaterialUICore;

const { color, spacing } = axiomTokens;

type ButtonProps = {
  error?: string;
};

export const VoucherContainerWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  rowGap: spacing[4],
  width: '100%',
});

export const VoucherInputWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  gap: spacing[4],

  [theme.breakpoints.down('sm')]: {
    gap: spacing[4],
  },
}));

export const TextField = styled(DSTextField)({
  '& .MuiFilledInput-input': {
    padding: '0 8px',
  },
});

export const Button = styled(DSButton)<ButtonProps>((error) => ({
  marginBottom: error ? '16px' : '0',
  color: color.typeface.pure,
}));
